// employee
export const GET_EMPLOYEE: { [x: string]: any } = {
  LOADING: "EMPLOYEE_GET_LOADING",
  SUCCESS: "EMPLOYEE_GET_SUCCESS",
  ERROR: "EMPLOYEE_GET_ERROR",
};

export const GET_SINGLE_EMPLOYEE: { [x: string]: any } = {
  LOADING: "SINGLE_EMPLOYEE_GET_LOADING",
  SUCCESS: "SINGLE_EMPLOYEE_GET_SUCCESS",
  ERROR: "SINGLE_EMPLOYEE_GET_ERROR",
};

export const GET_EMPLOYEE_GENERAL_INFO: { [x: string]: any } = {
  LOADING: "EMPLOYEE_GENERAL_INFO_GET_LOADING",
  SUCCESS: "EMPLOYEE_GENERAL_INFO_GET_SUCCESS",
  ERROR: "EMPLOYEE_GENERAL_INFO_GET_ERROR",
};

export const GET_EMPLOYEE_ASSETS: { [x: string]: any } = {
  LOADING: "EMPLOYEE_ASSETS_GET_LOADING",
  SUCCESS: "EMPLOYEE_ASSETS_GET_SUCCESS",
  ERROR: "EMPLOYEE_ASSETS_GET_ERROR",
};

export const ASSIGN_EMPLOYEE_DESK_0R_BED: { [x: string]: any } = {
  LOADING: "EMPLOYEE_DESK_0R_BED_ASSIGN_LOADING",
  SUCCESS: "EMPLOYEE_DESK_0R_BED_ASSIGN_SUCCESS",
  ERROR: "EMPLOYEE_DESK_0R_BED_ASSIGN_ERROR",
};

// export const UPDATE_EMPLOYEE: { [x: string]: any } = {
//   LOADING: "EMPLOYEE_UPDATE_LOADING",
//   SUCCESS: "EMPLOYEE_UPDATE_SUCCESS",
//   ERROR: "EMPLOYEE_UPDATE_ERROR",
// };

// export const DELETE_EMPLOYEE: { [x: string]: any } = {
//   LOADING: "EMPLOYEE_DELETE_LOADING",
//   SUCCESS: "EMPLOYEE_DELETE_SUCCESS",
//   ERROR: "EMPLOYEE_DELETE_ERROR",
// };
